module.exports = __webpack_public_path__ + "static/media/highlights (1).46cfe79c.jpg";